import { __assign, __rest } from "tslib";
/* eslint-disable no-param-reassign */
import React from "react";
import classNames from "classnames";
import { View, Text } from "../_core/components";
import { useConfig } from "../_util/use-config";
var defaultFormatter = function (i) { return i + "%"; };
export function Progress(_a) {
    var status = _a.status, _b = _a.percent, percent = _b === void 0 ? 0 : _b, className = _a.className, _c = _a.formatter, formatter = _c === void 0 ? defaultFormatter : _c, props = __rest(_a, ["status", "percent", "className", "formatter"]);
    var classPrefix = useConfig().classPrefix;
    if (percent < 0 || percent > 100) {
        console.error("Progress component 'percent' property limit to 0 ~ 100");
    }
    percent = Math.min(percent, 100);
    percent = Math.max(percent, 0);
    if (!status) {
        if (percent >= 100) {
            status = "success";
        }
        else {
            status = "default";
        }
    }
    var text = formatter(percent);
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-progress", className, "is-" + status) }, props),
        React.createElement(View, { className: classPrefix + "-progress__bar" },
            React.createElement(View, { className: classPrefix + "-progress__bar-inner", style: { width: percent + "%" } })),
        text && React.createElement(Text, { className: classPrefix + "-progress__value" }, text)));
}
//# sourceMappingURL=Progress.js.map